export const isAuthenticated = (user) => !!user;
